import wcShared from '@web-components/shared';
export function formatGroupEntity(type) {
    switch (type) {
        case 'admin':
            return wcShared?.translate('Administrateur');
        case 'owner':
            return wcShared?.translate('Responsable legal');
        case 'normal':
            return wcShared?.translate('Collaborateur');
        case 'client':
            return wcShared?.translate('Client');
        case 'external':
            return wcShared?.translate('Externe');
        case 'partner_admin':
            return wcShared?.translate('Acces complet');
        case 'partner_limited':
            return wcShared?.translate('Acces limite');
        default:
            return wcShared?.translate('Collaborateur');
    }
}
export function tutorialSubmit(id, payload) {
    wcShared?.httpCall('PUT', `/api/components/tutorial_stepper/${id}`, {
        steps: { steps: payload },
    });
}
function removeDiacritics(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
export function findMatchingGroups(haystack, needle) {
    const regExp = new RegExp(removeDiacritics(needle), 'gi');
    return regExp.test(removeDiacritics(haystack));
}
export const TUTORIAL_NEW_INTERFACE_ID = 6;
export const TUTORIAL_WHATS_NEW_ID = 7;
export const PAYLOAD_TUTORIAL_NEW_INTERFACE_STEP_0 = [
    {
        id: 0,
        state: true,
    },
    {
        id: 1,
        state: false,
    },
];
export const PAYLOAD_TUTORIAL_NEW_INTERFACE_STEP_1 = [
    {
        id: 0,
        state: true,
    },
    {
        id: 1,
        state: true,
    },
];
export const PAYLOAD_TUTORIAL_WHATS_NEW_STEP_0 = [
    {
        id: 0,
        state: true,
    },
];
